import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { ariaDescribedByIds, type WidgetProps } from '@rjsf/utils'
import { fieldHintOf, fieldNameOf } from '../displayLabel'
import { FormHint } from '../FormHint'
import styles from './CheckboxWidget.module.scss'

export const CheckboxWidget: FC<WidgetProps> = ({ id, label, value, schema, options, required, disabled, readonly, rawErrors, onChange, onBlur, onFocus }) => {
  const hint = fieldHintOf(id, schema.description)

  return (
    <Form.Check id={id} className='form-check align-items-start'>
      <span className={classNames(styles.box, 'd-flex align-items-center flex-shrink-0')}>
        <Form.Check.Input
          type='checkbox'
          checked={value === true}
          disabled={disabled || readonly}
          isInvalid={Boolean(rawErrors?.length)}
          aria-describedby={ariaDescribedByIds(id)}
          onChange={(event) => onChange(event.target.checked)}
          onBlur={() => onBlur(id, value)}
          onFocus={() => onFocus(id, value)}
        />
      </span>
      <span className='d-flex flex-column'>
        <Form.Check.Label>
          {fieldNameOf(id, label, schema, options.listItem)}
          {required ? (
            <>
              {' '}
              <span className='visually-hidden'>(required)</span>
            </>
          ) : null}
        </Form.Check.Label>
        {hint ? <FormHint id={hint.elementId}>{hint.text}</FormHint> : null}
      </span>
    </Form.Check>
  )
}
